import getConfig from 'next/config';
import { ImageCDNProvider } from '../../types';

import { getCloudinaryImageSrc } from './getCloudinaryImageSrc';

const { publicRuntimeConfig } = getConfig();
const { ASSETS_URL, CLOUDINARY_REMOTE_ASSETS_FOLDER } = publicRuntimeConfig;

export function publicAssetsImageSrcToCdnImageSrc(
  src: string,
  cdnProvider: ImageCDNProvider | undefined,
  format = 'auto',
): string {
  switch (cdnProvider) {
    case 'cloudinary':
      const assetsUrl = new URL(ASSETS_URL);
      const assetsPath = ASSETS_URL.replace(assetsUrl.protocol, '');
      const imageId = src.replace(`${assetsPath}/page/assets`, CLOUDINARY_REMOTE_ASSETS_FOLDER);

      return getCloudinaryImageSrc(imageId, format);

    case 'cloudflare':
      return `${src.replace('api/v1', `cdn-cgi/image/format=${format}/api/v1`)}`;
    default:
      return src;
  }
}
